import { formatNumber } from '../../../utils/formatUtils';
import { CONSOLIDATED_SUPPLY_TEXTS as TEXTS } from '../constants/consolidatedSupplyTexts';

const formatQuantity = (value) => formatNumber(value, { decimals: 3 });
const unitOf = (row) => row.unit;

/**
 * Columnas de la preparación de compra para `CompactTable`. Combina pedido con proyecto y
 * finalidad, y muestra la unidad debajo de las cantidades para que la tabla entre en el drawer.
 * @param {Object} params
 * @param {boolean} params.showOrigins Cantidades por pedido (true) o totales por material (false).
 * @param {Function} [params.renderQuantityInput] Recibe el renglón y devuelve el campo editable.
 * @returns {Array<Object>}
 */
export const buildConsolidatedSupplyColumns = ({ showOrigins, renderQuantityInput }) => [
  { key: 'article_name', label: TEXTS.article, secondary: (row) => row.article_code },
  ...(showOrigins ? [{
    key: 'order_number',
    label: TEXTS.orderDestination,
    width: 210,
    secondary: (row) => [row.destination_label, row.group_name].filter(Boolean).join(' · '),
  }] : []),
  { key: 'warehouse_name', label: TEXTS.warehouse, width: 170 },
  {
    key: 'available_quantity',
    label: TEXTS.available,
    width: 120,
    align: 'right',
    render: (row) => formatQuantity(row.available_quantity),
    secondary: unitOf,
  },
  showOrigins ? {
    key: 'quantity',
    sortKey: 'quantity_sort',
    label: TEXTS.quantity,
    width: 130,
    align: 'right',
    editable: true,
    render: renderQuantityInput,
  } : {
    key: 'quantity',
    sortKey: 'quantity_sort',
    label: TEXTS.quantity,
    width: 120,
    align: 'right',
    render: (row) => formatQuantity(row.quantity),
    secondary: unitOf,
  },
];
